import React, { useContext, useEffect, useState } from "react";
import Modal from "react-modal";
import {
  CustomModal,
  getModifiedScrollHeight,
} from "../../../../utils/UtilFunctions";
import { useNavigate } from "react-router";

import { Title } from "../../../../stories/Title/Title";
import Input from "../../../../stories/Input/Input";
import {
  empType,
  LicenseTypes,
  Operation,
  PageFor,
  TableHeaders,
} from "../../../../utils/Enum.types";
import {
  EMPTY_STRING,
  FETCH_MORE_DATA,
  ROWS_PER_PAGE,
  emptyMessage,
} from "../../../../utils/constants";
import { Button } from "../../../../stories/Button/Button";
import Edit from "../../../../images/EditProfile.svg";
import {
  GridAlignment,
  GridColDef,
  GridValidRowModel,
} from "@mui/x-data-grid-pro";
import Delete from "../../../../images/Delete.svg";

import useAssetTableJson from "../../../../json/useAssetTableJson";
import { TableHeaderProps } from "../../../../utils/types";
import { useLazyQuery, useMutation } from "@apollo/client";
import { GetCompanies, GetNotAllocatedIds } from "./queries/queries";

import { modalOpertaionFlag } from "../Index";
import {
  AddModalStyles,
  CustomModalStyles,
} from "../../../../styles/CustomModalStyles";

import useUrlParams from "../../../../customHooks/useUrlParams";
import { OrderDirection } from "../../../../utils/commonQueryTypes";
import { AppContext } from "../../../../context/context";
import { payloadTypes } from "../../../../context/reducer";
import {
  HEADER_TEXT_ALIGN,
  MARKS_TEXT_ALIGN,
  TABLE_ROW_HEIGHT,
} from "../../../../styles/Variables";
import { StyledDatagrid } from "../../../../styles/DatagridStyles";
import {
  AtsCompanyEdge,
  AtsCompanyOrderField,
  DeleteCompanyByIdResult,
  DeleteCompanyByIdVars,
  GetCompaniesResult,
  GetCompaniesVars,
  GetNotAllocatedIdsResult,
  GetNotAllocatedIdsVar,
  TableType,
} from "./queries/types";
import AddCompanies from "./AddCompany";
import DeleteModal from "../../../../customComponents/DeleteModal";
import { DeleteCompany } from "./queries/mutations";
import useLoggedInUserDetails from "../../../../customHooks/useLoggedInUserDetails";
import LoadingModal from "../../../pages/LoadingModal";
import Navbar from "../../../common/layout/Navbar";
import { useHotKey } from "../../../../utils/hotKeys";
import { SpecialKeys } from "../../../../utils/Enum.keys";
import useLabels from "../../../../customHooks/useLabels";

import useCompanyConfiguration from "../../../../customHooks/useCompanyConfiguration";
import ImportCompanies from "./ImportCompany";
import MessageModal from "../../../../customComponents/MessageModal";

export interface ModalType {
  operation: Operation;
  id: number;
  flag: boolean;
}

const Companies = () => {
  const { Users } = useAssetTableJson();

  const {
    USE_ENABLE_SUBSIDIARY,
    USE_ENABLE_SUBSIDIARY_SITE,
    USE_ENABLE_JUNCTION,
  } = useCompanyConfiguration();

  const navigate = useNavigate();

  const [importModal, setImportModal] = useState(false);
  const { state, dispatch } = useContext(AppContext);
  const { customer_id } = useUrlParams();
  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [employees, setEmployees] = useState<AtsCompanyEdge[]>([]);
  const [rows, setRows] = useState<GridValidRowModel[]>([]);
  const [addModal, setAddModal] = useState<modalOpertaionFlag>({
    operation: Operation.CREATE,
    flag: false,
  });
  const [deleteModal, setDeleteModal] = useState(false);
  const [message, setMessage] = useState(emptyMessage);
  const { user_details } = useLoggedInUserDetails();

  const [searchData, setSearchData] = useState("");

  const [GetCompany, { data, loading, fetchMore }] = useLazyQuery<
    GetCompaniesResult,
    GetCompaniesVars
  >(GetCompanies);

  const [DeleteSelectedCompany, { loading: deletionLoading }] = useMutation<
    DeleteCompanyByIdResult,
    DeleteCompanyByIdVars
  >(DeleteCompany, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const [getNotAllocatedIds] = useLazyQuery<
    GetNotAllocatedIdsResult,
    GetNotAllocatedIdsVar
  >(GetNotAllocatedIds);

  const dynamicHeaders: TableHeaderProps[] = Users.List.map((header) => ({
    headerName: header.headerName,
    cellClassName: header.cellClassName,
    field: header.field,
    headerAlign: header.headerAlign as GridAlignment,
    align: header.align as GridAlignment,
    flex: header.flex,
    hideable: header.hideable,
  }));
  const columns: GridColDef[] = [
    ...dynamicHeaders,

    {
      field: "actions",
      cellClassName: "td-actions-print ",
      headerClassName: "td-actions-print-header",
      headerAlign: HEADER_TEXT_ALIGN,
      align: MARKS_TEXT_ALIGN,
      headerName: TableHeaders.ACTION,
      renderCell: (params) => {
        return (
          <>
            <img
              src={Edit}
              alt="/"
              onClick={() => {
                dispatch({
                  type: payloadTypes.SET_COMPANY_ID,
                  payload: {
                    companyId: params.row.company_id,
                  },
                });
                setAddModal({
                  operation: Operation.UPDATE,
                  flag: true,
                });
              }}
            />
            <img
              src={Delete}
              alt="/"
              onClick={() => {
                dispatch({
                  type: payloadTypes.SET_COMPANY_ID,
                  payload: {
                    companyId: params.row.company_id,
                  },
                });
                setDeleteModal(!deleteModal);
              }}
            />
          </>
        );
      },
    },
  ];

  const HandleDelete = async () => {
    setDeleteModal(!deleteModal);
    DeleteSelectedCompany({
      variables: {
        ats_company_id: state.companyId,
        user_details,
      },
      refetchQueries: [
        {
          query: GetCompanies,
          variables: {
            after: null,
            customerID: customer_id ? customer_id : 0,
            empID: user_details.id,
            first: ROWS_PER_PAGE,
            orderBy: {
              direction: OrderDirection.ASC,
              field: AtsCompanyOrderField.NAME,
            },

            name: EMPTY_STRING,
          },
        },
      ],
    }).then(({ data }) => {
      if (data) {
        setMessage({
          flag: true,
          message: `${companyLabel} Deleted Sucessfully`,
          operation: Operation.DELETE,
        });
      }
    });
  };

  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetCompanies.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCompany) => {
          const filteredStudent = employees.find(
            (employee) => employee.node.id === newCompany.node.id
          );
          if (filteredStudent) {
            return {
              ...newCompany,
              node: {
                ...newCompany.node,
              },
            };
          }
          return newCompany;
        });
        setEmployees(updatedNewData);
        setRows(
          updatedNewData.map(({ node }, index) => ({
            id: index + 1,
            name: node.name,
            mobile: node.mobile,
            email: node.email,
            // user_type: node.regType,
            company_id: node.id,
            customerID: node.customerID,
          }))
        );
      } else {
        setEmployees(newData);
        setRows(
          newData.map(({ node }, index) => ({
            id: index + 1,
            name: node.name,
            mobile: node.mobile,
            email: node.email,
            // user_type: node.regType,
            company_id: node.id,
            customerID: node.customerID,
          }))
        );
      }
      setEndCursor(data.GetCompanies.pageInfo.endCursor);
    } // eslint-disable-next-line
  }, [data, loading]);

  useEffect(() => {
    const scrollTable = document.getElementsByClassName(
      "MuiDataGrid-virtualScroller"
    )[0] as Element;
    const handleScroll = (e: Event) => {
      const target = e.target as HTMLDivElement;
      const scrollTop = target.scrollTop;
      const scrollHeight = target.scrollHeight;
      const clientHeight = target.clientHeight;
      if (scrollTop + clientHeight >= getModifiedScrollHeight(scrollHeight)) {
        if (hasNextPage && !loading) {
          fetchMore({
            variables: {
              first: FETCH_MORE_DATA,
              after: endCursor,
            },
            updateQuery: (prevResult, { fetchMoreResult }) => {
              if (!fetchMoreResult) return prevResult;

              const newEdges = fetchMoreResult.GetCompanies.edges;
              const pageInfo = fetchMoreResult.GetCompanies.pageInfo;
              setEndCursor(pageInfo.endCursor);
              setHasNextPage(pageInfo.hasNextPage);

              const duplicateCheck = prevResult.GetCompanies.edges.filter(
                ({ node: { id } }) =>
                  newEdges.findIndex(
                    ({ node: { id: newId } }) => newId === id
                  ) !== -1
              );

              if (duplicateCheck.length > 0) return prevResult;

              return {
                GetCompanies: {
                  edges: [...employees, ...newEdges],
                  pageInfo,
                  totalCount: data ? data.GetCompanies.totalCount! : 0,
                },
              };
            },
          });
        }
      }
    };
    if (scrollTable && rows.length)
      scrollTable.addEventListener("scroll", handleScroll);

    return () => {
      if (scrollTable) scrollTable.removeEventListener("scroll", handleScroll);
    };
  }, [rows]);

  useEffect(() => {
    GetCompany({
      variables: {
        after: null,
        customerID: customer_id ? customer_id : 0,
        empID: user_details.id,
        first: ROWS_PER_PAGE,
        orderBy: {
          direction: OrderDirection.ASC,
          field: AtsCompanyOrderField.NAME,
        },

        name: searchData,
      },
    });
  }, [customer_id, user_details.id, GetCompany, searchData]);

  //hot key for addition ctrl+a
  useHotKey({
    handleFunc: () => {
      setAddModal({
        flag: true,
        operation: Operation.CREATE,
      });
    },
    specialCharacter: SpecialKeys.CTRL,
    charater: "a",
  });

  const { companyLabel } = useLabels();

  return (
    <>
      <Navbar NavType={LicenseTypes.CUSTOMER_USERS} />
      <Title>{companyLabel}</Title>
      <div className="cust_users">
        <div className="row g-0 cust_users--filters">
          <div className="col-2">
            <Input
              id="data_search"
              placeholder="Search ..."
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setSearchData(e.target.value)
              }
            />
          </div>
          <div className="col flex-end">
            {state.empSubType === empType.SYS_ADMIN ? (
              <Button
                mode="addnew"
                autoFocus
                onClick={() => {
                  setAddModal({
                    flag: true,
                    operation: Operation.CREATE,
                  });
                }}
              />
            ) : null}
          </div>
        </div>
        <div className="cust_users__tableblock">
          <StyledDatagrid
            columns={
              state.empSubType === empType.SYS_ADMIN ? columns : dynamicHeaders
            }
            rows={rows}
            rowHeight={TABLE_ROW_HEIGHT}
            onCellClick={async (params) => {
              if (params.field === "name") {
                if (USE_ENABLE_SUBSIDIARY) {
                  navigate(
                    `/${params.row.customerID}/company/${params.row.company_id}/subsidiary`
                  );
                } else if (USE_ENABLE_SUBSIDIARY_SITE) {
                  const result = await getNotAllocatedIds({
                    variables: {
                      companyID: params.row.company_id,
                      customerID: params.row.customerID,
                      table: TableType.COMPANY,
                      table_id: 0,
                    },
                  });

                  if (result.data?.GetNotAllocatedIds.subsidiaryID) {
                    navigate(
                      `/${params.row.customerID}/company/${params.row.company_id}/subsidiary/${result.data.GetNotAllocatedIds.subsidiaryID}/assetsite`
                    );
                  }
                } else if (USE_ENABLE_JUNCTION) {
                  const result = await getNotAllocatedIds({
                    variables: {
                      companyID: params.row.company_id,
                      customerID: params.row.customerID,
                      table: TableType.COMPANY,
                      table_id: 0,
                    },
                  });

                  if (result.data?.GetNotAllocatedIds.siteID) {
                    navigate(
                      `/${params.row.customerID}/company/${params.row.company_id}/subsidiary/${result.data.GetNotAllocatedIds.subsidiaryID}/site/${result.data.GetNotAllocatedIds.siteID}/junctions`
                    );
                  }
                }
              }
            }}
            disableRowSelectionOnClick
            hideFooter
          />
        </div>
        <div className="row ">
          <div className="col-2">
            {state.empSubType === empType.SYS_ADMIN ? (
              <Button
                mode={"excel"}
                type="button"
                onClick={() => {
                  setImportModal(!importModal);
                }}
              >
                Import
              </Button>
            ) : null}

            <Button mode="back" onClick={() => navigate(-1)} />
          </div>
          <div className="col flex-end">
            <div className="overall-total-count">
              Total Companies : <b>{data?.GetCompanies.totalCount}</b>
            </div>
          </div>
        </div>
      </div>
      <DeleteModal
        id={state.companyId}
        modalFlag={deleteModal}
        setModalFlag={setDeleteModal}
        handleDelete={HandleDelete}
      />
      <Modal isOpen={addModal.flag} style={AddModalStyles} ariaHideApp={false}>
        <AddCompanies
          setModalFlag={setAddModal}
          operation={addModal.operation}
        />
      </Modal>

      <CustomModal
        isOpen={importModal}
        onRequestClose={() => setImportModal(!importModal)}
        contentComponent={
          <ImportCompanies
            setModalFlag={setImportModal}
            NavType={LicenseTypes.COMPANY}
            pageType={PageFor.MODAL}
          />
        }
        style={CustomModalStyles}
      />
      <LoadingModal flag={(!searchData && loading) || deletionLoading} />
      <MessageModal
        handleClose={() => {
          setMessage(emptyMessage);
        }}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
    </>
  );
};

export default Companies;
